import { createSelector } from 'reselect';
import { userReducer, UserSliceType } from './user.reducer';

export const userSliceSelector = (state: any): any => state[userReducer.sliceName];

export const isLoadingSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.isLoading || false);

export const isLoggedInSelector = createSelector(
  userSliceSelector,
  () => window && window.location.href.split('#')[0].indexOf('mock=1') !== -1,
);

export const errorSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.error);
export const signupSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.signupSuccess);
export const inviteSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.inviteSuccess);
export const inviteCodeInvalidSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.inviteCodeInvalid);
export const signupUsernameSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.signupUsername);
export const verifyPhoneSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.verifyPhone);
export const shareableUrlSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.shareable_url);
export const IsSignupVerifiedSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.is_verified);
export const IsCreditSignupSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.is_credit);
export const tokenSelector = createSelector(userSliceSelector, (userSlice: UserSliceType) => userSlice.token);
export const requestDefaultInviteCodeSelector = createSelector(
  userSliceSelector,
  (userSlice: UserSliceType) => userSlice.request_default_invite_code,
);

export const cognitoIdentityResultSelector = createSelector(
  userSliceSelector,
  (userSlice: UserSliceType) => userSlice.cognito_identity_result,
);

export const ShowPlayerProfileSettingsBonusSelector = createSelector(
  userSliceSelector,
  (userSlice: UserSliceType) => userSlice.show_player_profile_settings_bonus,
);
